var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{name: _vm.$options.ROUTE.MAP}}},[_c('img',{staticClass:"logo__image",attrs:{"src":require("@/assets/logo.png"),"srcset":require("@/assets/logo@2x.png") + " 2x, " + require("@/assets/logo@3x.png") + " 3x","alt":"AI-Powered City"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }